// Dual synced Swipers with EXTERNAL pagination element
import Swiper from 'swiper';
import { Pagination, Controller, Navigation } from 'swiper/modules';
// If you load CSS via JS, import once in your main entry:
// import 'swiper/css';
// import 'swiper/css/pagination';

export function initApplicationListSliders(root = document) {
  const groups = root.querySelectorAll('.dpage-app-swipers');
  groups.forEach((group) => {
    if (group.__dpage_inited) return;
    group.__dpage_inited = true;

    const mediaEl     = group.querySelector('.js-application-swiper--media');
    const contentEl   = group.querySelector('.js-application-swiper--content');

    if (!mediaEl || !contentEl) return;

    // External controls (scoped)
    const footer        = group.querySelector('.application-card__footer-wrapper') || group;
    const paginationEl  = footer.querySelector('.swiper-pagination') || (() => {
      const p = document.createElement('div'); p.className = 'swiper-pagination'; footer.appendChild(p); return p;
    })();
    const prevEl        = footer.querySelector('.swiper-button-prev') || (() => {
      const b = document.createElement('button'); b.className = 'swiper-button-prev'; b.type = 'button'; b.setAttribute('aria-label','Previous slide'); footer.appendChild(b); return b;
    })();
    const nextEl        = footer.querySelector('.swiper-button-next') || (() => {
      const b = document.createElement('button'); b.className = 'swiper-button-next'; b.type = 'button'; b.setAttribute('aria-label','Next slide'); footer.appendChild(b); return b;
    })();

    // Fallback: create pagination if missing
    const pag = paginationEl || (() => {
      const p = document.createElement('div');
      p.className = 'swiper-pagination';
      const footer = group.querySelector('.application-card__footer-wrapper') || group;
      footer.appendChild(p);
      return p;
    })();

    // Media swiper (usually visual only)
    const mediaSwiper = new Swiper(mediaEl, {
      modules: [Controller],
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      watchOverflow: true,
      autoHeight: true,
      // Optional UX: uncomment to disable dragging on media
      // allowTouchMove: false,
    });

    // Content swiper (drives pagination)
    const contentSwiper = new Swiper(contentEl, {
      modules: [Pagination, Controller, Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      speed: 500,
      watchOverflow: true,
      pagination: {
        el: pag,            // <-- external element
        clickable: true,
      },
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
    });

    // Two-way sync
    mediaSwiper.controller.control = contentSwiper;
    contentSwiper.controller.control = mediaSwiper;
  });
}
